module.exports = __webpack_public_path__ + "static/media/Azure_titlePage.fee5db33.png";